import DefaultText from "./Text";
import styled, { css } from "styled-components";
import React from "react";
import { up } from "../lib/styles";

const TextComponent = (props) => (
  <DefaultText fontWeight="400" fontSize="22px" lineHeight="30px" {...props} />
);

const Text = styled(TextComponent)`
  ${({ noMargin }) =>
    css`
      font-size: 20px;
      margin-bottom: ${noMargin ? "0" : "24px"};

      ${up("mobile")} {
        font-size: 22px;
      }
    `}
`;

export default Text;
